import React from 'react';

type Props = {
  onClick?: () => void;
};
function LogoGradientIcon(props: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='19.948'
      height='19.948'
      viewBox='0 0 19.948 19.948'
      onClick={props.onClick}
    >
      <defs>
        <linearGradient
          id='linear-gradient'
          x1='0.5'
          x2='0.5'
          y2='1'
          gradientUnits='objectBoundingBox'
        >
          <stop offset='0' stopColor='#6affc6'></stop>
          <stop offset='1' stopColor='#5c6ef8'></stop>
        </linearGradient>
      </defs>
      <g data-name='Group 49' transform='translate(-233.895 -407.116)'>
        <g
          fill='url(#linear-gradient)'
          data-name='Path 5'
          transform='translate(233.895 407.116)'
        >
          <path
            d='M253.2 423.575l-7.564-14.042a1.677 1.677 0 00-2.965 0l-2.864 5.315.5.851 3.108-5.77a.839.839 0 011.483 0l7.564 14.042a.859.859 0 01-.017.834.832.832 0 01-.724.413H245.8l.48.842h5.433a1.693 1.693 0 001.483-2.485zm-16.611 1.643a.832.832 0 01-.724-.413.859.859 0 01-.017-.834l2.468-4.574-.5-.859-2.712 5.037a1.693 1.693 0 001.483 2.485h5.576l-.489-.842z'
            data-name='Path 9'
            transform='translate(-234.054 -407.798)'
          ></path>
          <path
            d='M253.779 423.013l-7.564-14.042a2.523 2.523 0 00-4.448 0l-2.62 4.86.5.859.5.851 3.108-5.77a.839.839 0 011.483 0l7.564 14.042a.859.859 0 01-.017.834.832.832 0 01-.724.413h-5.913l.48.842.489.842h4.945a2.533 2.533 0 002.217-3.731zm-12.265 2.047h-5.088a.832.832 0 01-.724-.413.859.859 0 01-.017-.834l2.468-4.574-.5-.859-.5-.859-2.957 5.492a2.53 2.53 0 002.224 3.732h6.065L242 425.9z'
            data-name='Path 10'
            transform='translate(-233.895 -407.64)'
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default LogoGradientIcon;